import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  @media (max-width: 1028px) {
    margin-top: 2rem;
  }
`;
export const SingleFeature = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 1rem;

  img {
    width: 1rem;
    height: 1rem;
    margin-left: 1rem;
  }

  p {
    font-size: 0.8rem;
    margin-bottom: 0;
    line-height: 27px;
    color: #565c64;
    text-align: right;

    span {
      font-weight: bold;
      position: relative;
      ::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 0.7rem;
        transform: translateY(100%);
        background: rgba(31, 198, 137, 0.2);
        z-index: -1;
      }
    }
  }
`;
